<template>
  <router-view/>
</template>

<style>

nav {
  padding: 8px;
}


</style>
